import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowLeft } from 'lucide-react';
import SavvyDataProposalCard from '../../components/savvydata/SavvyDataProposalCard.tsx';
import SavvyDataDemoContent from './SavvyDataDemoContent.tsx';

const ContentContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  overflow: 'auto',
  padding: theme.spacing(3),
}));

const BackButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: '#00FFFF',
  borderColor: 'rgba(0, 255, 255, 0.5)',
  '&:hover': {
    borderColor: '#00FFFF',
    background: 'rgba(0, 255, 255, 0.1)',
  },
}));

interface SavvyDataProposalContentProps {
  onBack: () => void;
}

const SavvyDataProposalContent: React.FC<SavvyDataProposalContentProps> = ({ onBack }) => {
  const [isDemo, setIsDemo] = React.useState(false);
  
  const handleStartDemo = () => {
    setIsDemo(true);
  };
  
  const handleBackFromDemo = () => {
    setIsDemo(false);
  };
  
  if (isDemo) {
    return <SavvyDataDemoContent onBack={handleBackFromDemo} />;
  }
  
  return (
    <ContentContainer>
      <BackButton
        variant="outlined"
        startIcon={<ArrowLeft size={16} />}
        onClick={onBack}
      >
        Back to Workspace
      </BackButton>
      
      <Typography variant="h4" sx={{ color: '#fff', mb: 3 }}>
        SavvyData Marketing Platform
      </Typography>
      
      <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 3 }}>
        Explore the SavvyData Marketing Platform solution. This AI-powered platform helps B2B 
        companies identify, engage, and convert high-value prospects through advanced 
        research and personalized communication.
      </Typography>
      
      <Box sx={{ width: '70%', margin: '0 auto', mb: 4 }}>
        <SavvyDataProposalCard onClick={handleStartDemo} />
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Button 
          variant="contained"
          size="large"
          onClick={handleStartDemo}
          sx={{
            background: 'linear-gradient(45deg, #8A2BE2 30%, #00CC99 90%)',
            boxShadow: '0 3px 5px 2px rgba(138, 43, 226, .3)',
            color: 'white',
            padding: '12px 32px',
          }}
        >
          Start Demo
        </Button>
      </Box>
    </ContentContainer>
  );
};

export default SavvyDataProposalContent; 